import React from "react";
import { CheckCircle2 } from "lucide-react";

const Stepper = ({ steps, current }) => {
  return (
    <div className="flex items-center justify-center gap-2 mb-10" data-testid="stepper">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <React.Fragment key={i}>
            <div className="flex items-center gap-2">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2 ${
                  done ? 'op-step-done' : active ? 'op-step-active' : 'op-step-future'
                }`}
                data-testid={`step-${i}`}
              >
                {done ? <CheckCircle2 size={18} /> : i + 1}
              </div>
              <span className={`text-xs font-medium hidden md:inline ${active ? 'text-[#7C3AED]' : done ? 'text-gray-700' : 'text-gray-400'}`}>{label}</span>
            </div>
            {i < steps.length - 1 && (
              <div className={`w-6 md:w-12 h-0.5 ${done ? 'bg-[#7C3AED]' : 'bg-gray-200'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
